module.exports = __webpack_public_path__ + "img/kaodian2.af300abd.png";